var React = require('react');

function Eternal (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"path1952_12_","style":{"opacity":"0.27"},"d":"M28.89,85.76l69.6-71.54L71,14.23L1.5,85.77L28.89,85.76z","key":0}),React.createElement("polygon",{"points":"98.5,14.24 98.48,14.24 76.18,37.16 76.18,62.8 28.99,14.23 1.5,14.23 1.55,14.28 1.51,14.28 1.51,85.76 \n\t23.83,62.79 23.83,37.18 71.1,85.76 98.49,85.77 98.46,85.74 98.5,85.74 ","key":1})]);
}

Eternal.defaultProps = {"version":"1.1","id":"Layer_2","x":"0px","y":"0px","viewBox":"0 0 100 100","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = Eternal;

Eternal.default = Eternal;
